import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

/** Old public /guides URLs → role-scoped guide after sign-in. */
export default function GuidesLegacyRedirect() {
  const { user, isAuthenticated } = useAuthStore();
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }
  const dest: Record<string, string> = {
    AGENCY: '/agency/guide',
    BRAND: '/brand/dashboard',
    KOL: '/kol/dashboard',
    ADMIN: '/admin/dashboard',
  };
  return <Navigate to={dest[user.role] ?? '/login'} replace />;
}
